import {ajax, getRequestUrl, formatData, uploadImg} from "../request";

// 活动管理





export default {
  //管理 --充值列表-奖励保存
  postRecharge(data, method) {
    return ajax('post', getRequestUrl('/api/Activity/postRecharge'), data, {
      method,
    });
  },

  //管理 --星空诗人保存
  poetSave(data, method) {
    return ajax('post', getRequestUrl('/api/Activity/poetSave'), data, {
      method,
    });
  },

  //管理 --奖池设置-抽奖券
  LotteryTicketList(data, method) {
    return ajax('post', getRequestUrl('/api/Activity/LotteryTicketList'), data, {
      method,
    });
  },

  //管理 --奖池设置-抽奖券新增删除
  LotteryTicketOperate(data, method) {
    return ajax('post', getRequestUrl('/api/Activity/LotteryTicketOperate'), data, {
      method,
    });
  },

  // 活动管理-添加活动黑名单
  ac_addBlackList(data, method) {
    return ajax('post', getRequestUrl('/api/Activity/addBlackList'), data, {
      method,
    })
  },

  // 活动管理-添加活动黑名单
  ac_actionBlackList(data, method) {
    return ajax('post', getRequestUrl('/api/Activity/actionBlackList'), data, {
      method,
    })
  },

  // 活动管理-删除活动黑名单
  ac_delBlackList(data, method) {
    return ajax('post', getRequestUrl('/api/Activity/delBlackList'), data, {
      method,
    })
  },

  // 活动管理-查找礼物
  ac_findGift(data, method) {
    return ajax('post', getRequestUrl('/activity/findGift'), data, {
      method,
    })
  },

  // 黑名单方案列表
  actionBlackList(data, method) {
    return ajax('post', getRequestUrl('/activity/actionBlackList'), data, {
      method,
    })
  },

  // 保存黑名单方案
  saveBlackPlan(data, method) {
    return ajax('post', getRequestUrl('/activity/actionBlackAdd'), data, {
      method,
    })
  },

  // 删除活动黑名单方案
  deleteBlackPlan(data, method) {
    return ajax('post', getRequestUrl('/activity/actionBlackDel'), data, {
      method,
    })
  },

  // 选择活动设置黑名单
  setBlackPlan(data, method) {
    return ajax('post', getRequestUrl('/api/Activity/setBlackPlan'), data, {
      method,
    })
  },

  // 选择活动设置隐藏名单
  setHidePlan(data, method) {
    return ajax('post', getRequestUrl('/api/ActivityHide/setHidePlan'), data, {
      method,
    })
  },

  // 隐藏名单列表
  actionHideList(data, method) {
    return ajax('post', getRequestUrl('/api/ActivityHide/actionHideList'), data, {
      method,
    })
  },

  // 删除隐藏名单
  delHideList(data, method) {
    return ajax('post', getRequestUrl('/api/ActivityHide/delHideList'), data, {
      method,
    })
  },

  // 解除改区限制
  regionChangeLimit(data, method) {
    return ajax('post', getRequestUrl('/api/Activity/regionChangeLimit'), data, {
      method,
    })
  },

  // 新用户审核-主列表
  InviteNewPeopleList(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/InviteAwardList'), data, {
      method,
    })
  },

  // 新用户审核-邀请人数统计
  InviteNewPeopleStatisticsList(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/inviterInvite'), data, {
      method,
    })
  },

  // 新用户审核-审核
  InviteNewPeopleExamine(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/inviteAwardReview'), data, {
      method,
    })
  },

  // 新用户审核-日周月排行
  examineStatisticsLists(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/inviteAwardStatistics'), data, {
      method,
    })
  },

  // 新用户审核-公会长申报审核列表
  userRewardApplyList(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/userRewardApplyList'), data, {
      method,
    })
  },

  // 新用户审核-公会长申报审核
  userRewardApplyReview(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/userRewardApplyReview'), data, {
      method,
    })
  },

  // 新用户审核-应用商店五星评价审核列表
  evaluationReviewList(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/evaluationReviewList'), data, {
      method,
    })
  },

  // 新用户审核-应用商店五星评价审核
  evaluationReview(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/evaluationReview'), data, {
      method,
    })
  },

  // 推广员管理-团队管理
  teamManagementList(data, method) {
    return ajax('post', getRequestUrl('/agent/teamList'), data, {
      method,
    })
  },
// 推广员管理-团队成员详情
  teamNumberData(data, method) {
    return ajax('post', getRequestUrl('/agent/teamNumberData'), data, {
      method,
    })
  },
  // 推广员管理-团队创建
  teamManagementCreate(data, method) {
    return ajax('post', getRequestUrl('/agent/teamCreate'), data, {
      method,
    })
  },
  // 推广员管理-踢出成员
  teamMemberDel(data, method){
    return ajax('post', getRequestUrl('/agent/delTeamMate'), data, {
      method,
    })
  },

  // 推广员管理-修改团队
  teamManagementUpdate(data, method) {
    return ajax('post', getRequestUrl('/agent/teamUpdate'), data, {
      method,
    })
  },

  // 推广员管理-审核查询列表
  teamReviewList(data, method) {
    return ajax('post', getRequestUrl('/agent/list'), data, {
      method,
    })
  },

  // 推广员管理-审核
  teamReviewed(data, method) {
    return ajax('post', getRequestUrl('/agent/reviewed'), data, {
      method,
    })
  },

  // 推广员管理-审核统计
  teamReviewData(data, method) {
    return ajax('post', getRequestUrl('/agent/reviewedData'), data, {
      method,
    })
  },

  // 推广员管理-推广团队数据
  teamData(data, method) {
    return ajax('post', getRequestUrl('/agent/teamData'), data, {
      method,
    })
  },

  // 推广员管理-团队成员详情
  teamNumberData(data, method) {
    return ajax('post', getRequestUrl('/agent/teamNumberData'), data, {
      method,
    })
  },

  // 推广员管理-修改前平台信息
  updateOtherAppData(data, method) {
    return ajax('post', getRequestUrl('/agent/updateOtherAppData'), data, {
      method,
    })
  },
  // 推广员管理-对接人列表
  contactPersonList(data, method) {
    return ajax('post', getRequestUrl('/agent/contactPersonList'), data, {
      method,
    })
  },
}



// WEBPACK FOOTER //
// ./src/js/https/Activity.js